import styled from "styled-components";

export const TaskCardContainer = styled.div`
  background-color: #303231ad;
  border-radius: 12px;
  padding: 20px;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 300px;
  position: relative;

  @media (max-width: 600px) {
    padding: 15px;
    border-radius: 5px;
  }
`;

export const TaskHeader = styled.div`
  margin-bottom: 16px;
`;

export const TaskTitleSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const AccentLine = styled.div`
  width: 3px;
  height: 40px;
  background-color: #4ade80;
  border-radius: 2px;
  flex-shrink: 0;
`;

export const TitleContent = styled.div`
  flex: 1;
  @media (max-width: 600px) {
    h3 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
    }
  }
`;

export const TaskTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
  line-height: 1.3;
`;

export const TaskDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #a0a0a0;
  line-height: 1.4;
`;

export const TaskMiddle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const RouteInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RouteLabel = styled.span`
  font-size: 14px;
  color: #6e6e6e;
  font-weight: 500;
`;

export const RouteCount = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;
`;

export const CountNumber = styled.span`
  font-size: 36px;
  font-weight: 700;
  color: white;
`;

export const CountUnit = styled.span`
  font-size: 14px;
  color: white;
  font-weight: 400;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const Button = styled.button`
  max-width: 300px;
  margin: 0 auto;
  width: 100%;
  padding: 15px 20px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  white-space: nowrap;

  &.btn-outline {
    border: 1px solid #4ade80;
    color: #4ade80;
    background-color: rgba(74, 222, 128, 0.1);

    &:hover {
      color: rgb(37, 101, 61);
      background-color: rgba(29, 108, 58, 0.1);
      border: 1px solid rgb(36, 108, 62);
    }
  }

  &.btn-filled {
    border: 1px solid #4ade80;
    background-color: #4ade80;
    color: #121212;

    &:hover {
      background-color: rgb(42, 142, 79);
    }
  }
  @media (max-width: 600px) {
    font-size: 13px;
    padding: 10px 15px;
  }
`;

export const TaskFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Separator = styled.div`
  flex: 1;
  height: 1px;
  background-color: #333;
  margin-right: 12px;
`;

export const TaskDate = styled.span`
  font-size: 12px;
  color: #a0a0a0;
  font-weight: 400;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;

  background: transparent;
  box-sizing: border-box;
  padding: 3px 5px;
  border: none;
  cursor: pointer;
  svg {
    color: #aaaaaa;
  }
`;
